import { BannerType } from "@/app/entities/Banner";

export const SMALL_CARD_SIZES = {
  [BannerType.INITIAL_PAGE]: {
    width: 216,
    height: 324,
  },
  [BannerType.LOGIN]: {
    width: 216,
    height: 324,
  },
  [BannerType.INVITE]: {
    width: 324,
    height: 324,
  },
  [BannerType.DASHBOARD_CARD]: {
    width: 350,
    height: 150,
  },
  [BannerType.DASHBOARD_MODAL]: {
    width: 350,
    height: 235,
  },
};

export const BIG_CARD_SIZES = {
  [BannerType.INITIAL_PAGE]: {
    width: 364,
    height: 546,
  },
  [BannerType.LOGIN]: {
    width: 364,
    height: 546,
  },
  [BannerType.INVITE]: {
    width: 546,
    height: 546,
  },
  [BannerType.DASHBOARD_CARD]: {
    width: 414,
    height: 177,
  },
  [BannerType.DASHBOARD_MODAL]: {
    width: 350,
    height: 235,
  },
};

export const CARD_SIZES_LABEL = {
  [BannerType.INITIAL_PAGE]: "720x1080",
  [BannerType.LOGIN]: "720x1080",
  [BannerType.INVITE]: "1200x1200",
  [BannerType.DASHBOARD_CARD]: "350x150",
  [BannerType.DASHBOARD_MODAL]: "350x235",
};

export const getCardSize = (type: BannerType) => {
  return SMALL_CARD_SIZES[type];
};

export const getBigCardSize = (type: BannerType) => {
  return BIG_CARD_SIZES[type];
};

export const getSizeLabel = (type: BannerType) => {
  return CARD_SIZES_LABEL[type];
};
